import { Component, Input } from '@angular/core'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'

@Component({
  standalone: true,
  selector: 'customer-portal-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  imports: [NgxSkeletonLoaderModule]
})
export class CPTSkeletonLoaderComponent {
  @Input()
  public loading: boolean
}
